import analytics from "@/analytics";
import { getUrlFromBranch } from "@/components/globalUtils";
import { notify } from "@/components/shared/AppToast";
import { t } from "@/localization";

// One Branch link opened in the iOS/Android app (AppRouting's linking
// subscriber). A sign-in link carries Cognito tokens that last about an hour:
// sign in with them first. If that fails, say so and still open the link (or
// the sign-in screen) instead of doing nothing.
export const handleBranchOpen = async (
  { error, params },
  { signInWithTokens, openUrl }
) => {
  if (params && params["+clicked_branch_link"]) {
    analytics.track("Open Link", params);
  }

  if (error) {
    console.warn("Branch error:", error);
    return;
  }

  if (params["+non_branch_link"]) {
    return;
  }

  if (!params["+clicked_branch_link"]) {
    return;
  }

  if (params.idToken && params["+match_guaranteed"]) {
    try {
      await signInWithTokens({
        idToken: params.idToken,
        accessToken: params.accessToken,
        username: params.username,
      });
    } catch (err) {
      console.warn("Branch sign-in link failed:", err?.message);
      notify.error(
        err?.code === "TOKENS_EXPIRED"
          ? t("This sign-in link has expired")
          : t("Couldn't sign you in from this link"),
        t("Please sign in to continue.")
      );
    }
  }

  openUrl(getUrlFromBranch(params));
};
